/**
 * Canonical lifestyle / amenity tags the smart-search LLM may assign when
 * `generateTags` is enabled. Matching the query is semantic (synonyms /
 * implications); the JSON values still have to be copied from this list.
 */
export const SMART_SEARCH_TAGS = [
  'open concept layout',
  'walk-in or walk-through closets',
  'natural light and skylights',
  'upstairs laundry',
  'quartz or granite countertops',
  'double garage',
  'stainless steel appliances',
  'ample or assigned storage',
  'near parks and pathways',
  'private fenced backyard',
  'spa-inspired ensuite',
  'soft-close or maple cabinetry',
  'party room or theatre',
  'home office or co-working space',
  'near river pathways',
  'near transit and downtown',
  'floor-to-ceiling or oversized windows',
  'amenity-rich building',
  'walk-in or walk-through pantry',
  'storage locker or in-suite storage',
  'stainless steel or premium appliances',
  "gourmet or chef's kitchen",
  'near shopping and dining',
  'near parks or park views',
  'near transit',
  'party or recreation room',
  'quartz countertops',
  'ample in-suite storage',
  'granite countertops',
  'private or covered balcony',
  'abundant natural light',
  'one or two parking spaces',
  'bright natural light',
  'walk-in closet or pantry',
  'walkable to shops',
  'two or three-car garage',
  'custom cabinetry and millwork',
  'in-suite laundry',
] as const;

export type SmartSearchTag = (typeof SMART_SEARCH_TAGS)[number];

export function isSmartSearchTag(value: string): value is SmartSearchTag {
  return SMART_SEARCH_TAGS.some(tag => tag === value);
}
